export default {
  setEmployees(state,value){
    state.employees=value
  }
}
